import { CSSObject, Theme } from '@core-ui/react-stitch';

const getOptionBeforeStyles = (theme: Theme): CSSObject => ({
  borderBottom: `3px solid ${theme.color.b1}`,
  borderRight: `3px solid ${theme.color.b1}`,
  content: '""',
  height: '11px',
  left: '1.25rem',
  position: 'absolute',
  transform: 'rotate(45deg)',
  width: '5px'
});

export default getOptionBeforeStyles;
